import GridContainer from "../components/GridContainer";
import ProjectDetails from "../components/projects/ProjectDetails";
import ProjectBody from "../components/projects/ProjectBody";
import TextLink from "../components/TextLink";
import ProjectTitle from "../components/projects/ProjectTitle";
import ProjectHero from "../components/projects/ProjectHero";
import LinkCard from "../components/projects/LinkCard";
import Divider from "../components/projects/Divider";
import ProjectMedia from "../components/Media";

export default function LOFSuit() {
    return (
        <GridContainer>
            <ProjectHero content="https://i.imgur.com/f38DEpv.png" />
            <ProjectTitle role="3D ART / MODDING">LEAP OF FAITH SUIT</ProjectTitle>
            <ProjectBody col={2}>
                This mod is a recreation of Miles Morales' suit from{' '}
                <TextLink link="https://www.imdb.com/title/tt4633694/">
                    Spider-Man: Into The Spider-Verse
                </TextLink>
                {' '}where Miles wears his jacket, hoodie, and the iconic Jordan 1s. When {' '}
                <TextLink link="https://store.steampowered.com/app/1817070/Marvels_SpiderMan_Remastered/">
                    Marvel's Spider-Man Remastered
                </TextLink>
                {' '} was released on PC, I started learning how to mod, and picked up Blender including rigging and weight painting to create custom suits for the game. by the time {' '}<TextLink link="https://store.steampowered.com/app/1817190/Marvels_SpiderMan_Miles_Morales/">
                    Marvel's Spider-Man: Miles Morales
                </TextLink>
                {' '} launched on PC, I was ready to remaster my original version of the "Leap of Faith" suit and improve its quality and this is the result.
                At first, I created the mod just for myself, but I decided to release it on <TextLink link="https://www.nexusmods.com/">
                    Nexusmods
                </TextLink>
                {' '}  and the response was overwhelmingly positive. I even saw people posting the photos online using this mod!
            </ProjectBody>
            <ProjectDetails
                role={['3D Modeling & Texturing']}
                collaborators={['-']}
                duration={['September 2022 - March 2025 (Last updated)']}
                tools={['Blender', 'Photoshop']}
            />
            <Divider />
            <LinkCard col={1} link="https://www.nexusmods.com/spidermanmilesmorales/mods/205">NEXUSMODS MOD PAGE</LinkCard>
            <LinkCard col={2} link="https://next.nexusmods.com/profile/EliKajiwara/mods">MY NEXUSMODS PROFILE</LinkCard>

            <ProjectBody title="THE BETA">
                This is the very first version this is how the suit looked like on my very first try in creating it in <TextLink link="https://store.steampowered.com/app/1817070/Marvels_SpiderMan_Remastered/">
                    Marvel's Spider-Man Remastered
                </TextLink> Which was also uploaded at NexusMods. This was the time when I was still experimenting with texturing, weight painting and modeling. It wasn't perfect but this was a good start for me.
                <ProjectMedia pAll src="https://i.imgur.com/GfxtmPn.png" />
                <ProjectMedia pAll src="https://i.imgur.com/N4aNSoL.png" />
            </ProjectBody>

            <ProjectBody title="VERSION 2">
                The V2 includes improved jacket, and hoodie mesh and textures. The V2 is for <TextLink link="https://store.steampowered.com/app/1817070/Marvels_SpiderMan_Remastered/">
                    Marvel's Spider-Man Remastered
                </TextLink> This V2 update of the mod includes 3 variants, One that has Hoodie up, one hoodie down, and one without the jacket but wearing the jordan 1s. The proportions are also slightly modified to match the proportions miles had in the movie.
                <ProjectMedia pAll src="https://i.imgur.com/QjOioBz.png" />
                <ProjectMedia pAll src="https://i.imgur.com/f90ZwUz.png" />
                <ProjectMedia pAll src="https://i.imgur.com/vkm0y6F.png" />
                <ProjectMedia pAll src="https://i.imgur.com/VuqGrG6.png" />
                <ProjectMedia pAll src="https://i.imgur.com/Aisa3VP.png" />
                <ProjectMedia pAll src="https://i.imgur.com/7g3fpUg.png" />
            </ProjectBody>

            <ProjectBody title="MARVEL'S SPIDER-MAN: MILES MORALES LAUNCHED">
                The Leap of Faith suit version for the <TextLink link="https://store.steampowered.com/app/1817190/Marvels_SpiderMan_Miles_Morales/">
                    Marvel's Spider-Man: Miles Morales
                </TextLink> is more refined and clean. I made the hoodie more accurate where in it covers more of the head just like the movie. Before releasing this to the public I gave this to a few of my modder friends for them to try. I was teasing this in the discord server to the public and received good feedback. by the time I released this to the public people made posts on youtube, tiktok, twitter even reddit and <TextLink link="https://www.thegamer.com/spider-man-miles-morales-mod-leap-of-faith-suit/">
                    articles online
                </TextLink> about the suit which is still crazy to me.
                <ProjectMedia pAll src="https://i.imgur.com/Wpi9DNA.png" />
                <ProjectMedia pAll src="https://i.imgur.com/uryVEIz.png" />
                <ProjectMedia pAll src="https://i.imgur.com/4uPNx34.png" />
                <ProjectMedia pAll src="https://i.imgur.com/brKczjC.png" />
            </ProjectBody>
        </GridContainer>
    )
}